module.exports = __webpack_public_path__ + "img/arrow-up-big-small.0f20ec61.svg";